<script>
    import ToastItem from './ToastItem.svelte';
    import { toast } from '@repo/stores/Messaging';
    import { UID } from '@repo/config/Utils';
    import { TOAST_DEFAULT_CLOSE_TIMEOUT } from '@repo/config/Global';

    let toasts = $state([]);
    toast.subscribe((v) => {
        if (v && v.type) {
            v.id = UID();
            toasts.push(v);
            // Ensure Svelte updates the array reactively
            toasts = [...toasts];
        }
    });

    function handleRemove(e) {
        const id = e?.detail;
        if (id) {
            toasts = toasts.filter((n) => n.id !== id);
            // Ensure Svelte updates the array reactively
            toasts = [...toasts];
        }
    }
</script>

<ul
    class="toasts"
    aria-live="polite"
    aria-atomic="true"
    role="presentation"
>
    {#each toasts as n, i}
        <ToastItem
            on:remove={handleRemove}
            id={n.id}
            type={n.type}
            message={n.message}
            autoClose={n.autoClose}
            closeTime={n.closeTime || TOAST_DEFAULT_CLOSE_TIMEOUT}
        />
    {/each}
</ul>

<style>
    .toasts {
        display: flex;
        flex-direction: column;
        position: fixed;
        bottom: 2rem;
        right: 2rem;
        z-index: 15000;
    }
</style>
